import throttle from 'lodash/throttle'

const SELECTORS = Selectors({
  eventDetails: 'event-details-page',
  eventTitle: 'event-header__inner',
  eventImagesWrapper: 'event-images-wrapper'
})

const props = {
  $eventDetails: document.querySelector(SELECTORS.asClass('eventDetails')),
  $eventTitle: document.querySelector(SELECTORS.asClass('eventTitle')),
  $eventImages: document.querySelector(SELECTORS.asClass('eventImagesWrapper'))
}

const fn = {
  init: () => {
    fn.bindEvents()

    if (props.$eventImages) {
      fn.repositionImages()
    }
  },

  bindEvents: () => {
    if (props.$eventImages) {
      window.addEventListener('resize', throttle(fn.repositionImages, 250))
    }
  },

  repositionImages: () => {
    if (window.matchMedia('(min-width: 1024px)').matches) {
      const titleHeight = props.$eventTitle.offsetHeight
      props.$eventImages.style.top = `${-titleHeight}px`
    } else {
      props.$eventImages.style.removeProperty('top')
    }
  }
}

export default {
  can: () => props.$eventDetails,
  run: fn.init
}
